<template>
  <div class="row">
    <div class="col-md-12">
      <order-return-difference/>
    </div>
    <div class="col-md-12">
      <div v-if="isLoading" class="col-md-12 text-right">
        <app-spinner/>
      </div>
      <template v-else>
        <hr>
        <div class="row" v-if="draftRefund">
          <div class="col-md-2">
            <h4>Refund Summary:</h4>
          </div>
          <div class="col-md-6">
            <refund-transactions :transactions="draftRefund.transactions"/>
          </div>
          <div class="col-md-4 text-right">
            <el-button @click="cancel" type="danger">Cancel</el-button>
            <el-button @click="createRA" type="success">Create RA</el-button>
          </div>
        </div>
      </template>
    </div>
  </div>
</template>

<script>
  import {mapState, mapActions} from 'vuex';
  import {
    currency,
    underscoresToSpaces,
    capitalize,
  } from '../../../filters';
  import AppSpinner from '../../ui/AppSpinner';
  import OrderReturnDifference from './OrderReturnDifference';
  import RefundTransactions from '../Shared/RefundTransactions';
  import {
    ORDER_RETURN_CREATE_RA,
  } from '../../../store/modules/order/return/types';
  import {notify} from "../../../utils";

  export default {
    name: 'OrderReturnConfirmationPage',
    components: {
      AppSpinner,
      OrderReturnDifference,
      RefundTransactions,
    },
    filters: {
      currency,
      underscoresToSpaces,
      capitalize,
    },
    computed: {
      ...mapState({
        isLoading: state => state.orderReturn.loading,
        order: state => state.orderReturn.order,
        draftRefund: state => state.orderReturn.draftRefund,
      }),
    },
    methods: {
      ...mapActions({
        create: ORDER_RETURN_CREATE_RA,
      }),
      cancel() {
        this.$router.push({path: 'update'});
      },
      createRA() {
        this.create().then(() => {
          this.$router.push({path: 'success'});
        }, (err) => {
          notify(err, 'error');
        });
      },
    },
    created() {
      if (!this.order) {
        this.$router.push({path: 'update'});
      }
    },
    mounted() {
      window.scrollTo(0, 0);
    },
  };
</script>
